import {
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import * as labels from "config.labels";
import * as staticDataService from "services/staticDataService";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const NONE_KEY = "__NONE__";

const StatusReason = ({ status, reason, onChange, size, hiddenLabel }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const { data: statusLabels, isLoading } = staticDataService.useConfigQuery(
    "layer_status_labels_v2"
  );

  const reasons = statusLabels?.reasons?.[status] ?? [];

  return reasons.length === 0 ? (
    <></>
  ) : (
    <FormControl
      variant={"filled"}
      fullWidth
      size={size}
      hiddenLabel={hiddenLabel}
    >
      {!hiddenLabel && (
        <InputLabel>
          {translateLabel(labels.STATUS_REASON_LABEL, {
            default: "Status Reason",
          })}
        </InputLabel>
      )}
      <Select
        value={reason || NONE_KEY}
        onChange={(e) => {
          const value = e?.target?.value;
          onChange(value === NONE_KEY ? null : value);
        }}
        disabled={isLoading}
      >
        <MenuItem value={NONE_KEY}>{"None"}</MenuItem>
        {reasons.length > 0 && <Divider />}
        {reasons.map((reason, index) => (
          <MenuItem value={reason.reasonKey} key={index}>
            {reason.displayName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StatusReason;
